import React, { useState, useMemo, useEffect } from "react";
import Datepicker from "tailwind-datepicker-react";
import { IsAllow } from "../../utils/allowHelper/AllowHelper";
import FormError from "../formError/FormError";

const getLocalISOString = () => {
  const now = new Date();
  return new Date(
    now.getTime() - now.getTimezoneOffset() * 60000
  ).toISOString();
};

const ClientFormDateSignUp = ({
  client,
  onChange,
  translate,
  allow,
  form,
  readOnly,
}) => {
  const [show, setShow] = useState(false);
  const [date, setDate] = useState(new Date());
  const [key, setKey] = useState(0);

  useEffect(() => {
    onChange({ target: { name: "dateSignUp", value: date } });
    setKey((prevKey) => prevKey + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  useEffect(() => {
    if (!client) return;
    if (!client.dateSignUp) return;
    if (client.dateSignUp === date) return;
    const initialDate = client.dateSignUp
      ? client.dateSignUp
      : getLocalISOString();

    setDate(initialDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client]);

  const dateOptions = useMemo(
    () => ({
      title: translate("date-sign-up"),
      autoHide: true,
      todayBtn: true,
      clearBtn: false,
      minDate: new Date("2000-01-01"),
      theme: {
        background: "bg-gray-50 dark:bg-gray-700",
        text: "text-gray-900 dark:text-white",
        disabledText: "text-slate-300",
        input: "h-14",
      },
      icons: {
        prev: () => <span>{translate("previous")}</span>,
        next: () => <span>{translate("next")}</span>,
      },
      datepickerClassNames: "absolute z-50",
      defaultDate: new Date(date),
      language: "en",
      weekDays: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
      inputNameProp: "dateSignUp",
      inputIdProp: "dateSignUp",
      inputPlaceholderProp: translate("select-date"),
      inputDateFormatProp: { day: "numeric", month: "long", year: "numeric" },
    }),
    [translate, date]
  );

  const handleChangeDate = (selectedDate) => {
    if (!(selectedDate instanceof Date)) {
      return;
    }
    const localISO = new Date(
      selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000
    ).toISOString();
    setDate(localISO);
  };

  if (!IsAllow(allow, "customer-01")) return null;
  return (
    <div className="relative mb-4">
      <label className="label block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        {translate("date-sign-up")}
      </label>
      {readOnly ? (
        <input
          type="text"
          name="dateSignUp"
          value={
            date
              ? new Date(date).toLocaleDateString(undefined, {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })
              : ""
          }
          disabled={readOnly}
          className="input bg-gray-100 dark:bg-gray-600 cursor-not-allowed"
        />
      ) : (
        <Datepicker
          key={key}
          options={dateOptions}
          onChange={handleChangeDate}
          show={show}
          setShow={setShow}
        />
      )}
      <FormError form={form} name="dateSignUp" />
    </div>
  );
};
export default ClientFormDateSignUp;
